import { Box, BoxProps } from '@mui/material'
import { FC } from 'react'
import { useTheme, styled } from '@mui/material/styles'
import { FastfoodIcon } from 'components/images'

export const ItemImageBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'wide',
})<BoxProps & { wide?: boolean }>((props) => {
  const theme = props.theme
  const wide = props.wide
  return {
    alignSelf: 'stretch',
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.grey[100]}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: wide ? '55%' : 100,
    minWidth: wide ? 0 : 100,
    [theme.breakpoints.down('sm')]: {
      width: wide ? '55%' : 80,
      minWidth: wide ? 0 : 80,
    },
  }
})

export const ItemImage: FC<BoxProps & { src?: string; wide?: boolean }> = (
  props,
) => {
  const theme = useTheme()
  const { src, sx, wide, ...rest } = props
  return src ? (
    <ItemImageBox
      wide={wide}
      {...rest}
      sx={{
        ...sx,
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
      }}
    />
  ) : (
    <ItemImageBox
      wide={wide}
      sx={{
        ...sx,
        '& svg': {
          marginY: 'auto',
          color: theme.palette.primary.main,
          width: 80,
          height: 'fit-content',
        },
        [theme.breakpoints.down('sm')]: {
          '& svg': {
            width: 64,
          },
        },
      }}
      {...rest}
    >
      <FastfoodIcon />
    </ItemImageBox>
  )
}
